import { Permission, userHasPermission } from "../permissions";
import { userIsLoggedIn, userIsRegistered } from "../roles";
import {
  LOGIN_ACTION_REDIRECT,
  LOGIN_ACTION_REDIRECT_URL,
  URL_PARAM_ON_LOGIN_ACTION,
  URL_PARAM_OPEN_LOGIN_POPUP,
} from "../../Login/loginConstants";
import { ACTIVE_QUOTE_PAGE, CART_PAGE, MY_ACCOUNT_PAGE, REGISTER_PAGE } from "./staticUrls";
import { resolveApiUrl, resolveUrl } from "./urlResolver";
import { BEARINGX_API_URL, CURRENT_LANGUAGE, IS_US_SITE } from "../constants";

export function redirectToUrl(url: string) {
  window.location.href = resolveUrl(url);
}

export const resolveCartPageUrl = () =>
  userHasPermission(Permission.ADD_TO_QUOTE)
    ? ACTIVE_QUOTE_PAGE
    : userHasPermission(Permission.ADD_TO_CART)
      ? CART_PAGE
      : "";

export const resolveBulkAddUrl = () =>
  userHasPermission(Permission.ADD_TO_QUOTE)
    ? resolveApiUrl("/quote/add/bulk")
    : userHasPermission(Permission.ADD_TO_CART)
      ? resolveApiUrl("/cart/add/bulk")
      : "";

// TODO: Deprecated
export function redirectOrReload(url: string) {
  redirectToUrl(url);
}

export const canVisitSTC = () => !userIsLoggedIn() || userIsRegistered();

export const getRedirectToRegisterPage = ({ targetPage, openLogin }: { targetPage?: string; openLogin?: boolean }) => {
  if (!targetPage) {
    targetPage = window.location.pathname + window.location.search;
  }

  const params = new URLSearchParams();
  params.append(URL_PARAM_ON_LOGIN_ACTION, LOGIN_ACTION_REDIRECT);
  params.append(LOGIN_ACTION_REDIRECT_URL, targetPage);
  if (openLogin) {
    params.append(URL_PARAM_OPEN_LOGIN_POPUP, "true");
  }
  return REGISTER_PAGE + "?" + params.toString();
};

export const getQuoteDetailsUrl = (quoteNumber: string) => `${MY_ACCOUNT_PAGE}/quotes/detail?id=${quoteNumber}`;
export const getOrderDetailsUrl = (schaefflerOrderNo: string) => `${MY_ACCOUNT_PAGE}/order?id=${schaefflerOrderNo}`;

type ContractDetailUrlParams = {
  sapMaterialNumber: string;
  packCode: string;
  contractNumber: string;
  contractPosition: string;
};
export const getContractDetailsUrl = ({
  sapMaterialNumber,
  packCode,
  contractNumber,
  contractPosition,
}: ContractDetailUrlParams) =>
  `${MY_ACCOUNT_PAGE}/contractDetails/${contractNumber}/${sapMaterialNumber}/${packCode}/${contractPosition}`;

export const isCurrentPage = (url: string) => window.location.href.includes(url);

export const getBearingXURL = (bearingXId: string) => {
  // bearingXDesignation
  const separators = { us: "dot", eu: "comma" };
  const region = {
    us: { lang: "En_US", separator: separators.us },
    de: { lang: "de_DE", separator: separators.eu },
    fr: { lang: "Fr_fr", separator: separators.eu },
    es: { lang: "Es_es", separator: separators.eu },
    cn: { lang: "Cn_cn", separator: separators.eu },
    ru: { lang: "RU_RU", separator: separators.eu },

    // alias
    zh: { lang: "Cn_cn", separator: separators.eu },
    // fallback
    fallback: { lang: "En_US", separator: separators.eu },
  };
  // CURRENT_LANGUAGE
  const regionData =
    IS_US_SITE && CURRENT_LANGUAGE === "en"
      ? region.us
      : region[CURRENT_LANGUAGE as keyof typeof region] || region.fallback;
  return `${BEARINGX_API_URL}product/basicfrequencies/pdf/${bearingXId}/${regionData.lang}/${regionData.separator}`;
};

export enum REGISTRATION_PATHS {
  REGISTER_EMAIL = "/registered/user/confirmation",
  REGISTER_ACCOUNT = "/registered/user/complete",
  MY_ACCOUNT = "/my-account",
}

export const userOnRegistrationConfirmationEmailPage = (): boolean =>
  window.location.href.indexOf(REGISTRATION_PATHS.REGISTER_EMAIL) > 0;

export const userOnRegistrationConfirmatioAccountPage = (): boolean =>
  window.location.href.indexOf(REGISTRATION_PATHS.REGISTER_ACCOUNT) > 0;

export const userOnMyAccountPage = (): boolean => window.location.href.indexOf(REGISTRATION_PATHS.MY_ACCOUNT) > 0;

export const isForkPage = () => isCurrentPage("/static/welcome");
export const isDatasheetPage = () => isCurrentPage("/datasheet/");
export const isProductPage = () => isCurrentPage("/p/");
export const isSearchPage = () => isCurrentPage("/searchpage/");
